import type { Product } from '~/common/schemas/product'
import { type PaginatedParameters, type PaginatedResponse, apiClient } from '.'

export type FilterValue = {
    value: string | number
    label: string
}

export type Filter = {
    field: string
    lookup: string
    select_multiple: boolean
    can_select_exclusive?: boolean
    values: FilterValue[]
}

class ProductApi {
    getProductListing = async (
        userId: number,
        params: Record<string, number | string[]> & PaginatedParameters = {}
    ): Promise<PaginatedResponse<Product>> => {
        const searchParams = new URLSearchParams()

        Object.entries(params).forEach(([key, value]) => {
            if (!value) {
                return
            }

            if (Array.isArray(value)) {
                value.forEach((v) => {
                    searchParams.append(key, v)
                })

                return
            }

            searchParams.append(key, value.toString())
        })

        if (!params.order_by) {
            searchParams.set('order_by', '-date_created')
        }

        return apiClient.get(`users/${userId}/products/`, { searchParams }).json()
    }

    getProductFilters = async (userId: number): Promise<Filter[]> => {
        return await apiClient.get(`users/${userId}/filter-values/products/`).json()
    }

    updateProductStatus = async (productId: number, status: string): Promise<{ id: number }> => {
        return await apiClient
            .patch(`products/${productId}/status/`, { json: { id: productId, status } })
            .json<{ id: number }>()
    }

    deleteProduct = async (productId: number): Promise<void> => {
        return await apiClient.delete(`products/${productId}/`).json()
    }
}

export const productApi = new ProductApi()
